import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'src/store';
import { UploaderType } from 'src/shared/types';

export type PortfolioFilesState = {
    searchText: string;
    uploadedByFilter: Record<UploaderType, boolean>;
};

const initialState: PortfolioFilesState = {
    searchText: '',
    uploadedByFilter: { [UploaderType.NatureMetrics]: true, [UploaderType.Client]: true },
};

const portfolioFilesSlice = createSlice({
    name: 'siteFiles',
    initialState,
    reducers: {
        setSearchText: (state, action: PayloadAction<string>) => {
            state.searchText = action.payload;
        },
        setUploadedByFilter: (state, action: PayloadAction<{ key: UploaderType; value: boolean }>) => {
            state.uploadedByFilter[action.payload.key] = action.payload.value;
        },
        resetFilters: state => {
            state.searchText = '';
            state.uploadedByFilter = { [UploaderType.NatureMetrics]: true, [UploaderType.Client]: true };
        },
    },
});

export const { setSearchText, setUploadedByFilter, resetFilters } = portfolioFilesSlice.actions;

export const getPortfolioFilesState = (state: RootState) => state.portfolio.portfolioFiles;
export const getSearchText = (state: RootState) => getPortfolioFilesState(state).searchText;
export const getUploadedByFilter = (state: RootState) => getPortfolioFilesState(state).uploadedByFilter;

export default portfolioFilesSlice.reducer;
